export const unwrapData = (response, fallback = []) => {
  if (response?.data?.data !== undefined) {
    return response.data.data;
  }

  if (response?.data !== undefined) {
    return response.data;
  }

  return fallback;
};

export const getErrorMessage = (error, fallback = 'No se pudo completar la operación') => {
  return (
    error?.response?.data?.error?.message ||
    error?.response?.data?.message ||
    error?.message ||
    fallback
  );
};
